import React from "react";
import { PieChartOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { FaDatabase, FaUser } from "react-icons/fa6";
// import logofull from "../../assets/Images/logofull.png"
// import logoicon from "../../assets/Images/logo-icon.svg"

const { Sider } = Layout;

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const items: MenuItem[] = [
  // getItem("Dashboard", "", <PieChartOutlined />),
  getItem("User Management", "usermanagement", <FaUser />, [
    // getItem("Menu", "menu"),
    // getItem("Rights", "rights"),
    // getItem("User Type", "usertype"),
    getItem("User", "user"),
  ]),
  getItem("Masters", "masters", <FaDatabase />, [
    getItem("Banner", "banner"),
    getItem("CMS", "cms"),
    getItem("Seo Tag", "seotag"),
    getItem("Testimonial", "testimonial"),
    getItem("Gallery", "gallery"),
    getItem("Blog", "blog"),
    getItem("Service", "service"),
    getItem("Core Service", "coreservice"),
    getItem("FAQ", "faq"),
    // getItem("Team Member", "teammember"),
    // getItem("Client", "client"),
    
    // getItem("Destination", "destination"),
    // getItem("Course", "course"),
    // getItem("News", "news"),
    // getItem("Branch", "branch"),
    // getItem("Useful Links", "usefullinks"),
    getItem("Setting", "setting"),
    getItem("Inquiry", "inquiry"),
    getItem("Howi It Works", "howitworks"),
  ]),
  // getItem("Quotation", "quotation", <PiListPlusFill />),
  // getItem("Inquiries", "inquiries", <RiContactsBook2Fill />),
];

interface HeaderProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
  };

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const allowedKeys = new Set(userResponse?.map((item) => item.MenuKey));

  function filterMenuItems(menuItems: MenuItem[]): MenuItem[] {
    return menuItems.reduce((filteredItems, item: any) => {
      if (allowedKeys.has(item.key)) {
        if (item.children) {
          const filteredChildren = filterMenuItems(item.children);
          filteredItems.push({ ...item, children: filteredChildren });
        } else {
          filteredItems.push(item);
        }
      } else if (item.children) {
        const filteredChildren = filterMenuItems(item.children);
        if (filteredChildren.length > 0) {
          filteredItems.push({ ...item, children: filteredChildren });
        }
      }
      return filteredItems;
    }, [] as MenuItem[]);
  }

  let filteredItems = filterMenuItems(items);

  const hasDashboardAccess = userResponse?.some(
    (item) => item.MenuKey === "dashboard"
  );
  if (hasDashboardAccess) {
    filteredItems = [
      getItem("Dashboard", "", <PieChartOutlined />),
      ...filteredItems,
    ];
  }

  function mapToGetItemFormat(menuItems: MenuItem[]): MenuItem[] {
    return menuItems.map((item: any) =>
      getItem(
        item.label,
        item.key,
        item.icon,
        item.children ? mapToGetItemFormat(item.children) : undefined
      )
    );
  }

  const formattedItems = mapToGetItemFormat(filteredItems);
  {
    0 && console.log("formattedItems", formattedItems);
  }

  return (
    <Sider
      width={250}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div className="drawer-logo">
        {/* <img src={logofull} alt="solar-mitra-logo" style={{height:"100%" , width:"100%" ,}} /> */}
        {/* <img src={logofull} alt="solar-mitra-logo" /> */}
        <h3 style={{ textAlign: "center", color: "white", margin: 0 }}>SM</h3>
      </div>
      <Menu
        className="sider-scroll"
        style={{
          overflow: "auto",
          height: "calc(100vh - 115px)",
        }}
        onClick={onClick}
        theme="dark"
        defaultSelectedKeys={[""]}
        selectedKeys={[location.pathname?.substring(1)?.split("/")[0]]}
        mode="inline"
        // items={formattedItems}
        items={items}
      />
    </Sider>
  );
};

export default Header;
